export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";